import components from './components.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
// import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
// import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
// import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
// import integrationApps from './integrationApps.json';
// import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
// import macros from './macros.json';
import report from './report.json';
import autoreports from './autoreports.json';
import monitor from './monitor.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
// import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import typeaheadMgmt from './typeaheadMgmt.json';
import functionMgmt from './functionMgmt.json';
import sensitiveWords from './sensitiveWords.json';
import call from './call.json';
import smart from './smart.json';

export default {
  ...components,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  // ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emoji,
  ...generalSettings,
  // ...helpCenter,
  ...inboxMgmt,
  // ...integrationApps,
  // ...integrations,
  ...labelsMgmt,
  ...login,
  // ...macros,
  ...report,
  ...autoreports,
  ...monitor,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  // ...sla,
  ...teamsSettings,
  ...whatsappTemplates,
  ...inbox,
  ...general,
  ...datePicker,
  // ...customRole,
  ...typeaheadMgmt,
  ...functionMgmt,
  ...sensitiveWords,
  ...call,
  ...smart,
};
